import React from "react";
// Wrapper for plus.svg image created for fill and stoke color dynamically set
const BackIcon = props => {
    const {width, height} = props
    return (
        <svg width={width} height={height} viewBox="0 0 60 60" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>0174_plus_150pt</title>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Assets_icone" transform="translate(-1038.000000, -7854.000000)" fill="#000000" fill-rule="nonzero">
                    <g id="0174_plus_150pt" transform="translate(1038.000000, 7854.000000)">
                        <path d="M55.385,25.675 L34.325,25.675 L34.325,4.615 C34.3249999,2.22636851 32.3886315,0.290000129 30,0.290000129 C27.6113685,0.290000129 25.6750001,2.22636851 25.675,4.615 L25.675,25.675 L4.615,25.675 C2.22636846,25.675 0.29,27.6113685 0.29,30 C0.29,32.3886315 2.22636846,34.325 4.615,34.325 L25.675,34.325 L25.675,55.385 C25.675,57.7736315 27.6113685,59.71 30,59.71 C32.3886315,59.71 34.325,57.7736315 34.325,55.385 L34.325,34.325 L55.385,34.325 C56.9301737,34.325 58.3579731,33.5006597 59.13056,32.1625 C59.9031468,30.8243404 59.9031468,29.1756596 59.13056,27.8375 C58.3579731,26.4993403 56.9301737,25.675 55.385,25.675 Z" id="Path"></path>
                    </g>
                </g>
            </g>
        </svg>
    )
}
export default BackIcon